import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button';
import classes from '../card-control-panel/card-control-panel.scss';
export const ConfirmCreditCardRemovingPopup = ({
  isOpen = false,
  onClose,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "ConfirmPublicApiCardRemovingPopup",
    showCloseButton: true,
    open: isOpen,
    onClose: onClose,
    title: renderTitle(),
    content: renderContent({
      onSubmit,
      onClose
    }),
    contentClass: classes.contentButtons
  });
};
const renderContent = ({
  onSubmit,
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.wrapper
}, /*#__PURE__*/React.createElement(Button, {
  type: ButtonType.defaultGrey,
  className: classes.button,
  onClick: onSubmit,
  textTransform: ButtonTextTransform.none
}, "Remove"), /*#__PURE__*/React.createElement(Button, {
  type: ButtonType.primary,
  className: classes.button,
  onClick: onClose,
  textTransform: ButtonTextTransform.none
}, "Keep"));
const renderTitle = () => /*#__PURE__*/React.createElement("div", {
  className: classes.title
}, "Are you sure you want to remove this credit card?");